export default __webpack_public_path__ + "static/media/checkgreen.85d6608c.png";